import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

export default function AuthorDetails({ author: authorProp }) {

    const { state } = useLocation();
    const { id } = useParams();

    const [author, setAuthor] = useState(
        authorProp || state?.author || null
    );

    //////////////////////////////////////////////////
    // Fetch if page refreshed (state lost)
    useEffect(() => {
        if (!author && id) {
            fetchAuthorById();
        }
    }, [id]);

    const fetchAuthorById = async () => {
        try {
            const res = await fetchAuthorById(id);
            setAuthor(res);
        } catch (error) {
            console.log(error);
        }
    };

    //////////////////////////////////////////////////
    if (!author) return <p>Loading...</p>;

    return (
        <div>
            <h2>{author.author_name}</h2>
            <img
                src={`https://api.uyirmozhy.in/assets/images/authors/${author.author_photo}`}
                alt="author"
                width="120"
            />
            <p>Pen Name: {author.pen_name}</p>
            <p>Email: {author.author_email}</p>
            <p>Phone: {author.author_phone}</p>
            <p>Address: {author.address}</p>
            <p>Biography: <span dangerouslySetInnerHTML={{ __html: author?.biography }}></span></p>

        </div>
    );
}